import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

const useNavigateTab = () => {
  const navigate = (href: string) => {
    const newTab = window.open(href, '_blank');
    if (newTab) {
      newTab.focus();
    }
  };

  return navigate;
};

export const withSubRoutes = (route: string) => `${route}/*`;

/**
 * @deprecated Use `createSubRouteRef` from `@backstage/core-plugin-api` directly.
 * The ExternalRouteRef half of the pair is unnecessary for internal plugin routes.
 * See docs/guides/05-routes.md for the updated pattern.
 */
export const createSubRouteRefsPair = <
  Path extends string,
  Id extends string,
  Optional extends boolean = false,
>({
  optional,
  ...config
}: {
  id: Id;
  path: Path;
  parent: RouteRef;
  optional?: Optional;
}): [SubRouteRef<{ path: Path; id: Id }>, ExternalRouteRef<any, Optional>] => {
  const params = (config.path.match(/:([a-zA-Z0-9_]+)/g) || []).map(param =>
    param.substring(1),
  );

  return [
    createSubRouteRef(config),
    createExternalRouteRef({
      id: config.id,
      params,
      optional,
    }),
  ];
};

/**
 * @deprecated Use `createRouteRef` from `@backstage/core-plugin-api` directly.
 * The ExternalRouteRef half of the pair is unnecessary for internal plugin routes.
 * See docs/guides/05-routes.md for the updated pattern.
 */
export const createRootRouteRefsPair = <Optional extends boolean = false>({
  id,
  optional,
}: {
  id: string;
  optional?: Optional;
}): [RouteRef, ExternalRouteRef<any, Optional>] => {
  return [
    createRouteRef({ id }),
    createExternalRouteRef({
      id,
      optional,
    }),
  ];
};

export {
  useNavigateTab,
  // ref. react-router-dom
  useNavigate,
  useLocation,
  Navigate,
};
